import React from 'react';
import { useState, useEffect } from 'react';
import { GrDocumentPdf, GrDocumentExcel, GrDocumentWord } from 'react-icons/gr';
import { DownloadIcon } from '../../pages/icons';

const FileIcon = ({ fileUrl }) => {
  const [fileExtension, setFileExtension] = useState('');

  useEffect(() => {
    const extension = fileUrl.split('.').pop();
    setFileExtension(extension.toLowerCase());
  }, [fileUrl]);

  const getIcon = () => {
    switch (fileExtension) {
      case 'pdf':
        return <GrDocumentPdf size={20} className="react-icons red" />;
      case 'doc':
      case 'docx':
        return <GrDocumentWord size={20} className="react-icons blue" />;
      case 'xlsx':
      case 'xls':
      case 'csv':
        return <GrDocumentExcel size={20} className="react-icons green" />;
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return <img src={fileUrl} alt={''} height={50} width={50} />;
      default:
        return <DownloadIcon style={{ color: 'purple' }} />;
    }
  };

  return <div>{getIcon()}</div>;
};

export default FileIcon;
